import useComputed from '@/hooks/use-computed'
import api from '@/services/api/sgtdEnrollmentRequest.js'
import titleCase from '@/utils/title-case'
import { immerable } from "immer"
import { useState } from 'react'
import { groupBy, uniqBy, uniq } from 'lodash'

class ApprovalRequests {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.userId = params.userId
		this.requestType = params.requestType
		this.orgId = params.orgId
		this.status = params.status
		this.comment = params.comment
		this.user = params.user
		this.orgPersona = params.orgPersona
		this.organizationUseCases = params.organizationUseCases
		this.created = params.created
		this.modified = params.modified
		this.createdBy = params.createdBy
		this.modifiedBy = params.modifiedBy
	}
}


const useSGTDEnrollmentRequest = (queryParam) => {

	const [items, setItems] = useComputed([])
	const [currentItem, setCurrentItem] = useState(null)
	const [meta, setMeta] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	const [useCase, setUseCase] = useState({})
	const [personaItems, setPersonaItems] = useState([])
	const [myInfoConfig, setMyInfoConfig] = useState()

	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		const { meta } = data

		if (!Array.isArray(data.admin_requests)) {
			return setError('Request is not an array')
		}

		const serializedData = data.admin_requests.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new ApprovalRequests(params))
		setMeta(meta)
		return setItems(newItems)

	}

	async function getConfig() {

		const [error, data] = await api.getConfig()

		if (error) {
			return setError(error)
		}

		const serializedData = serializeConfig(data)
		return setMyInfoConfig(serializedData)

	}

	async function find(parameter) {
		setLoading(true)
		const params = parameter ? parameter : "";

		const [error, data] = await api.getRequest(params)

		setLoading(false)

		if (error) {
			return setError(error)
		}

		const serializedData = serialize(data)
		const newItems = new ApprovalRequests(serializedData)
		const persona = newItems?.orgPersona?.map(item =>{ 
			let selectedPersonas = { 
				id:item.persona.personaId, 
				name:item.persona.personaName, 
				$selected: item.status === 'APPROVED' ? true:false 
			}
			if(newItems.status === 'PENDING_APPROVAL'){
				return {...selectedPersonas, $selected:true}
			}
			return selectedPersonas;
		})
		setPersonaItems(persona)
		setUseCase(newItems?.orgPersona[0]?.useCase)
		setItems(newItems)
		return
	}



	function serialize(entry) {
		return {
			created: entry.created,
			modified: entry.modified,
			createdBy: entry.createdBy,
			modifiedBy: entry.modifiedBy,
			id: entry.id,
			userId: entry.userId,
			requestType: entry.requestType,
			orgId: entry.orgId,
			status: entry.status,
			comment: entry.comment,
			user: entry.user,
			orgPersona: entry.orgPersona,
			organizationUseCases: entry.organizationUseCases,
		}
	}

	function serializeConfig(entry) {
		return {
			companyAppointment: entry.companyAppointment,
			companyStatus: entry.companyStatus,
			companyTypes: entry.companyTypes,
			countryOfIncorp: entry.countryOfIncorp,
			nationality: entry.nationality
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		meta,
		useCase,
		personaItems,
		setPersonaItems,
		getConfig,
		myInfoConfig
	}

}

export default useSGTDEnrollmentRequest;
